module.exports = __webpack_public_path__ + "static/media/anders.5600a8a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/anders.jpg
// module id = 614
// module chunks = 0